module.exports = __webpack_public_path__ + "static/media/cross-border-payment-lightning-network.dd052800.jpg";